// frontend/src/screens/Terms.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { localizedValue } from '../localization/presentationLanguage';
const termsText = (es, en) => localizedValue({ es, en });

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div id="termsBgHost" style={styles.host}>
      <style>{`
        @keyframes wheel-spin {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to   { transform: translate(-50%, -50%) rotate(360deg); }
        }
        @keyframes twinkle {
          0%, 100% { opacity: .55; transform: translateY(0); }
          50% { opacity: .9; transform: translateY(-2px); }
        }

        /* Asegura fondo consistente (evita “líneas” o cortes de tono al scrollear) */
        html, body { background: #3b0a70; }

        #termsBgHost{
          position: relative;
          min-height: 100svh;
          min-height: 100dvh;
          width: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          overscroll-behavior-y: auto;
          isolation: isolate;
          /* espacio para botón + header */
          padding-top: calc(env(safe-area-inset-top) + 18px);
          padding-bottom: max(18px, env(safe-area-inset-bottom));
        }

        /* Capas de fondo (estilo Welcome/Login) */
        #termsBgHost .bgBase{
          position: fixed;
          inset: 0;
          z-index: -3;
          pointer-events: none;
          background:
            radial-gradient(120% 100% at 50% 30%, rgba(255,215,0,0.12), rgba(75,0,130,0.18)),
            linear-gradient(180deg, #3b0a70 0%, #4a0f90 100%);
          background-color: #3b0a70;
        }

        #termsBgHost .bgGlow{
          position: fixed;
          inset: 0;
          z-index: -2;
          pointer-events: none;
          background:
            radial-gradient(100vmax 100vmax at 52% 46%, rgba(218,165,32,0.12) 0%, rgba(218,165,32,0.06) 30%, rgba(106,13,173,0.05) 55%, transparent 70%);
          mix-blend-mode: soft-light;
          filter: blur(2px) saturate(1.06) brightness(1.05);
          opacity: 1;
        }

        #termsBgHost .bgStars{
          position: fixed;
          inset: 0;
          z-index: -1;
          pointer-events: none;
          background:
            radial-gradient(1px 1px at 20% 30%, rgba(255,255,255,0.9), transparent 60%),
            radial-gradient(1px 1px at 80% 70%, rgba(255,255,255,0.7), transparent 60%),
            radial-gradient(1px 1px at 50% 10%, rgba(255,255,255,0.8), transparent 60%),
            radial-gradient(1px 1px at 10% 90%, rgba(255,255,255,0.6), transparent 60%);
          background-repeat: repeat;
          background-size: 320px 320px;
          animation: twinkle 12s linear infinite;
          opacity: .65;
        }

        #termsBgHost .wheel{
  position: fixed;
  top: 50%;
  left: 50%;
  width: min(96vmin, 980px);
  height: min(96vmin, 980px);
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-image: url('/logo/Zodiacus.jpeg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  box-shadow: 0 0 70px rgba(0,0,0,0.22), inset 0 0 16px rgba(0,0,0,0.25);
  filter: brightness(1.06) contrast(1.1) saturate(1.08);
  pointer-events: none;
  z-index: -1;

  /* 🔥 giro suave igual Welcome / Login */
  animation: wheel-spin 160s linear infinite;
  will-change: transform;
  transform-origin: center center;

  /* Feather para evitar borde del JPG */
  -webkit-mask-image: radial-gradient(circle at 50% 50%, rgba(0,0,0,1) 98%, rgba(0,0,0,0) 100%);
          mask-image: radial-gradient(circle at 50% 50%, rgba(0,0,0,1) 98%, rgba(0,0,0,0) 100%);
}

        /* Vignette sutil para legibilidad */
        #termsBgHost .vignette{
          position: fixed;
          inset: 0;
          z-index: -1;
          pointer-events: none;
          background: radial-gradient(120vmax 120vmax at 50% 45%, transparent 0 62%, rgba(0,0,0,0.10) 90%, rgba(0,0,0,0.18) 100%);
        }

        /* Barra superior discreta (como banner) */
        #termsBgHost .topRibbon{
          position: sticky;
          top: 0;
          z-index: 5;
          padding: calc(env(safe-area-inset-top) + 10px) 12px 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          background: linear-gradient(180deg, rgba(0,0,0,0.28), rgba(0,0,0,0.08));
          -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
          border-bottom: 1px solid rgba(218,165,32,0.22);
        }
        #termsBgHost .topTitle{
          flex: 1;
          text-align: center;
          font-family: "Cormorant Garamond", "Cinzel", serif;
          font-style: italic;
          font-weight: 700;
          letter-spacing: .02em;
          color: rgba(255, 234, 160, 0.92);
          text-shadow: 0 1px 0 rgba(0,0,0,0.55), 0 0 10px rgba(218,165,32,0.35);
          white-space: normal;
          overflow: visible;
          text-overflow: unset;
          line-height: 1.15;
        }

        /* Botón volver premium */
        #termsBgHost .backBtn{
          appearance: none;
          border: 1px solid rgba(218,165,32,0.55);
          background: linear-gradient(135deg, rgba(255,238,170,0.96), rgba(218,165,32,0.96));
          color: #2a0051;
          font-weight: 900;
          border-radius: 12px;
          padding: 10px 12px;
          cursor: pointer;
          box-shadow: 0 10px 22px rgba(0,0,0,0.25);
          text-shadow: 0 1px 1px rgba(255,255,255,0.35);
          transition: transform .12s ease, box-shadow .12s ease, filter .12s ease;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          white-space: nowrap;
        }
        #termsBgHost .backBtn:hover{ transform: translateY(-1px); box-shadow: 0 14px 28px rgba(0,0,0,0.28); filter: saturate(1.04) brightness(1.02); }
        #termsBgHost .backBtn:active{ transform: translateY(0); box-shadow: 0 10px 22px rgba(0,0,0,0.22); }

        /* Card glass */
        #termsBgHost .card{
          width: min(920px, calc(100vw - 24px));
          margin: 14px auto 24px;
          border-radius: 18px;
          border: 1px solid rgba(218,165,32,0.28);
          background: linear-gradient(180deg, rgba(255,255,255,0.86), rgba(255,250,230,0.78));
          box-shadow: 0 22px 60px rgba(0,0,0,0.26), 0 2px 8px rgba(218,165,32,0.10);
          -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
          padding: clamp(16px, 3.2vw, 30px);
          color: #2a0051;
        }

        #termsBgHost .h1{
          margin: 0;
          text-align: center;
          font-family: "Cinzel", "Cormorant Garamond", serif;
          font-weight: 900;
          letter-spacing: .2px;
          font-size: clamp(1.55rem, 4.4vw, 2.4rem);
          background: linear-gradient(90deg, #4B0082 0%, #7f39b5 40%, #DAA520 88%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          text-shadow: 0 2px 16px rgba(218,165,32,0.20);
        }

        #termsBgHost .subtitle{
          text-align: center;
          margin: 10px auto 18px;
          max-width: 60ch;
          color: rgba(45, 8, 76, 0.86);
          font-weight: 700;
          line-height: 1.35;
          font-size: clamp(.95rem, 2.4vw, 1.05rem);
        }

        #termsBgHost .section{
          margin-top: 14px;
          padding: 14px 14px;
          border-radius: 14px;
          border: 1px solid rgba(75,0,130,0.14);
          background: rgba(75,0,130,0.05);
        }

        #termsBgHost .ol{
          margin: 0;
          padding-left: 18px;
          line-height: 1.7;
          color: rgba(54, 33, 94, 0.95);
          font-weight: 650;
          font-size: 1rem;
        }
        #termsBgHost .ol li{ margin: 10px 0; }

        #termsBgHost .footer{
          display: flex;
          justify-content: center;
          margin-top: 18px;
        }
        #termsBgHost .linkBtn{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 12px 16px;
          border-radius: 12px;
          border: 1px solid rgba(75,0,130,0.22);
          background: linear-gradient(135deg, #DAA520, #FFD54F);
          color: #4B0082;
          font-weight: 900;
          text-decoration: none;
          box-shadow: 0 12px 26px rgba(218,165,32,0.28);
          transition: transform .12s ease, box-shadow .12s ease;
        }
        #termsBgHost .linkBtn:hover{ transform: translateY(-1px); box-shadow: 0 16px 30px rgba(218,165,32,0.34); }
        #termsBgHost .linkBtn:active{ transform: translateY(0); box-shadow: 0 12px 26px rgba(218,165,32,0.28); }

        /* Mobile tuning */
        @media (max-width: 520px){
          #termsBgHost .wheel{ width: 92vmin; height: 92vmin; opacity: .92; }
          #termsBgHost .topTitle{
            font-size: .92rem;
            max-width: 100%;
          }
          #termsBgHost .backBtn{ padding: 9px 10px; border-radius: 11px; }
        }

        @media (prefers-reduced-motion: reduce){
          #termsBgHost .wheel{ animation: none !important; }
          #termsBgHost .bgStars{ animation: none !important; }
        }
      `}</style>

      {/* Background layers */}
      <div className="bgBase" aria-hidden="true" />
      <div className="bgGlow" aria-hidden="true" />
      <div className="bgStars" aria-hidden="true" />
      <div className="wheel" aria-hidden="true" />
      <div className="vignette" aria-hidden="true" />

      {/* Sticky top ribbon */}
      <div className="topRibbon">
        <button type="button" className="backBtn" onClick={() => navigate('/home')} aria-label={termsText('Volver a registro', 'Back to registration')}>
          <span aria-hidden>⬅</span> {termsText('Volver', 'Back')}
        </button>
        <div className="topTitle">{termsText('Zodiacus · Términos & Condiciones', 'Zodiacus · Terms & Conditions')}</div>
        <div style={{ width: 92 }} aria-hidden="true" />
      </div>

      {/* Content */}
      <main className="card" role="main" aria-label={termsText('Términos y Condiciones', 'Terms and Conditions')}>
        <h1 className="h1">{termsText('Términos y Condiciones', 'Terms and Conditions')}</h1>
        <p className="subtitle">{termsText('Por favor, leé atentamente antes de usar la plataforma.', 'Please read carefully before using the platform.')}</p>

        <div className="section">
          <ol className="ol">
            <li>{termsText('El servicio se ofrece “tal cual”, pudiendo cambiar sin previo aviso.', 'The service is provided “as is” and may change without notice.')}</li>
            <li>{termsText('Te comprometés a usar la plataforma respetando a otros usuarios.', 'You agree to use the platform respectfully toward other users.')}</li>
            <li>{termsText('No está permitido subir contenido ilegal, ofensivo o que viole derechos.', 'Uploading illegal, offensive, or rights-infringing content is prohibited.')}</li>
            <li>{termsText('Podemos suspender cuentas ante incumplimientos o fraude.', 'We may suspend accounts for violations or fraud.')}</li>
            <li>{termsText('El emparejamiento zodiacal es recreativo y no garantiza resultados.', 'Zodiac matching is for entertainment and does not guarantee outcomes.')}</li>
          </ol>
        </div>

        <div className="footer">
          <Link to="/home" className="linkBtn">{termsText('← Volver al inicio', '← Back to Home')}</Link>
        </div>
      </main>
    </div>
  );
}

const styles = {
  host: {
    width: '100%',
    minHeight: '100dvh',
    background: 'transparent',
  },
};
